import PayPage from "./PayPage/PayPage";
import HitSnagPage from "./HitSnag/HitSnagPage";
import SomethingWentWrong from "./SomethingWentWrong";
import NotFoundPage from "./NotFoundPage/NotFoundPage";
import { NotAuthorizedPage } from "./NotAuthorizedPage";
import { LeasingWizard } from "../wizard/leasing/LeasingWizard";
import ServiceRequestForm from "../ServiceRequestForm";
import ServiceRequestUpdateForm from "../ServiceRequestUpdateForm";
import UnsubscribePage from "../UnsubscribePage";

export const MainPages = {
  hitSnag: {
    pathExact: true,
    anon: true,
    path: "/hit-snag",
    title: "Hit a snag",
    type: "HIT_SNAG_PAGE",
    view: HitSnagPage,
  },
  notAuthorized: {
    anon: true,
    path: "/unauthorized",
    title: "Not Authorized",
    type: "PAGE_NOT_AUTHORIZED",
    view: NotAuthorizedPage,
  },
  payAch: {
    anon: true,
    path: "/payment/:req_uid",
    title: "Home",
    type: "PAGE_PAYMENT",
    view: PayPage,
  },
  somethingWentWrong: {
    anon: true,
    path: "/something-went-wrong",
    title: "Something Went Wrong",
    type: "PAGE_SOMETHING_WENT_WRONG",
    view: SomethingWentWrong,
  },
  autoLeasingPage: {
    pathExact: true,
    anon: true,
    path: "/auto/lease/wizard",
    type: "AUTO_LEASE_WIZARD",
    view: LeasingWizard,
  },
  serviceRequestForm: {
    pathExact: true,
    anon: true,
    path: "/service-request",
    type: "SERVICE_REQUEST_FORM",
    view: ServiceRequestForm,
  },
  serviceRequestUpdateForm: {
    pathExact: true,
    anon: true,
    path: "/service-request-update/:uuid",
    type: "SERVICE_REQUEST_UPDATE_FORM",
    view: ServiceRequestUpdateForm,
  },
  unsubscribe: {
    pathExact: true,
    anon: true,
    path: "/unsubscribe",
    title: "Unsubscribe",
    type: "UNSUBSCRIBE_PAGE",
    view: UnsubscribePage,
  },
  notFound: {
    anon: true,
    path: "*",
    title: "Page Not Found",
    type: "PAGE_NOT_FOUND",
    view: NotFoundPage,
  },
};

export default MainPages;

export const MainArea = {
  pages: MainPages,
};
